export const headCells = [
  {
    id: "customerName",
    numeric: false,
    disablePadding: true,
    label: "Customer name",
  },
 
  {
    id: "phone1",
    numeric: true,
    disablePadding: false,
    label: "Phone",
  },
 
  {
    id: "status",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "area",
    numeric: true,
    disablePadding: false,
    label: "Address",
  },
  {
    id: "bloodTestDate",
    numeric: true,
    disablePadding: false,
    label: "Date",
  },
  {
    id: "bloodTestTime",
    numeric: true,
    disablePadding: false,
    label: "Time for sample collection",
  },
  {
    id: "action",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
  
 
];
export const Source = [
  { id: "whatsapp", name: "Whatsapp" },

  { id: "facebook", name: "Facebook" },
  { id: "instagram", name: "Instagram" },
  { id: "google", name: "Google" },
  { id: "walk-in", name: "Walk-In" },

  { id: "twitter", name: "Twitter" },
  { id: "linkedin", name: "Linkedin" },
  { id: "youtube", name: "Youtube" },
];
